import { ProveAuthType } from 'enums/ProveAuthType';

import Api, { FetchMethodType } from './Api';

export interface StartAuthenticationRequest {
  mobileNumber: string;
  isCoborrowerFlow?: boolean;
}

interface StartAuthenticationResponse {
  responseType: ProveAuthType;
  sessionId?: string;
  authenticationLink?: string;
  errorStatus?: string;
  errorDescription?: string;
}

export interface CompleteAuthenticationRequest {
  vfp: string;
}

export interface CompleteMobileAuthRequest {
  vfp: string;
  phoneNumber: string;
  dob: string;
}

export interface CompleteInstantAuthenticationResponse {
  success: boolean;
}

export interface CompleteMobileAuthenticationResponse {
  success: boolean;
  data: any;
}

export interface CheckIsMFACompleteRequest {
  sessionId: string;
  dob: string;
  phoneNumber: string;
}

export interface CheckIsMFACompleteResponse {
  isComplete: boolean;
}

export interface GetBorrowerEligibilityRequest {
  phoneNumber: string;
}

export interface GetBorrowerEligibilityResponse {
  eligibility: any;
}

export interface IdentityBorrowerRequest {
  phoneNumber: string;
  dob: string;
}

export interface IdentityBorrowerResponse {
  individual: any;
}

export default class ProveApi extends Api {
  public async startInstantAuthentication(body: StartAuthenticationRequest) {
    return this.fetch<StartAuthenticationResponse>(`/startAuthentication`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async completeInstantAuthentication(body: CompleteAuthenticationRequest) {
    return this.fetch<CompleteInstantAuthenticationResponse>(`/endAuthentication`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async completeMobileAuth(body: CompleteMobileAuthRequest) {
    return this.fetch<CompleteMobileAuthenticationResponse>(`/completeMobileAuthentication`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async checkIsMFAComplete(body: CheckIsMFACompleteRequest) {
    return this.fetch<any>(`/checkAuthenticationComplete`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }
}

export const proveApi = new ProveApi(`${process.env.REACT_APP_API_URL}/identity-verification`);
